
/**
 * @class
 * @description Factory class interface
*/
export default class Factory{

    /**
     * @method create Instance a concrete object (not implemented)
     */
    static create(){
        throw "Not implemented"
    }
}